import type { PsdSeries } from '../../types';

export const aggregatePsdSeries = (series: PsdSeries[]): PsdSeries => {
  if (series.length === 0) {
    return { frequencies: [], psd_lf: [], psd_hf: [] };
  }

  const frequencies = series[0].frequencies;
  const psdLf = new Array(frequencies.length).fill(0);
  const psdHf = new Array(frequencies.length).fill(0);

  series.forEach(entry => {
    entry.psd_lf.forEach((value, index) => {
      psdLf[index] += value;
    });
    entry.psd_hf.forEach((value, index) => {
      psdHf[index] += value;
    });
  });

  const count = series.length;

  return {
    frequencies,
    psd_lf: psdLf.map(value => value / count),
    psd_hf: psdHf.map(value => value / count),
  };
};
